export const WoodSwatch = ({ light = "#D9B98A", dark = "#8A5A2B", seed = 1, className = "" }) => {
  const fid = `wood-${seed}`;
  const planks = [0, 1, 2, 3];
  return (
    <svg
      viewBox="0 0 600 400"
      preserveAspectRatio="xMidYMid slice"
      className={className}
      aria-hidden="true"
      data-testid={`wood-swatch-${seed}`}
    >
      <defs>
        <filter id={fid} x="-5%" y="-5%" width="110%" height="110%">
          <feTurbulence type="fractalNoise" baseFrequency="0.008 0.28" numOctaves="4" seed={seed} result="noise" />
          <feColorMatrix in="noise" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0.8 0.8 0.8 0 0" result="alphaNoise" />
          <feComponentTransfer in="alphaNoise" result="grain">
            <feFuncA type="gamma" amplitude="1.1" exponent="4.5" offset="0" />
          </feComponentTransfer>
          <feFlood floodColor={dark} result="flood" />
          <feComposite in="flood" in2="grain" operator="in" />
        </filter>
      </defs>
      <rect width="600" height="400" fill={light} />
      <rect width="600" height="400" filter={`url(#${fid})`} opacity="0.6" />
      {planks.map((i) => (
        <line key={i} x1="0" y1={100 * (i + 1)} x2="600" y2={100 * (i + 1)} stroke={dark} strokeOpacity="0.22" strokeWidth="2" />
      ))}
    </svg>
  );
};
